
import React, { useState, useEffect } from 'react';
import { MultiSelect } from "@/components/ui/multi-select";
import { KolDataWithDates } from '@/types/table';

interface Option {
  value: string;
  label: string;
  type?: 'Campaign' | 'Topic';
  icon?: React.ReactNode;
  iconColor?: string;
}

interface MultiSelectTopicCellProps {
  row: KolDataWithDates;
  getAllCampaignsAndTopics: () => Array<{value: string; label: string; type: 'Campaign' | 'Topic'; iconColor?: string}>;
  updateRow: (id: string, field: string, value: any) => Promise<void>;
}

export const MultiSelectTopicCell: React.FC<MultiSelectTopicCellProps> = ({
  row,
  getAllCampaignsAndTopics,
  updateRow
}) => {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  // Initialize selected items from row data
  useEffect(() => {
    if (row.campaign_bu) {
      // Handle both string (legacy) and array (new jsonb) formats
      let items: string[] = [];
      if (Array.isArray(row.campaign_bu)) {
        items = row.campaign_bu.filter((item): item is string => Boolean(item));
      } else if (typeof row.campaign_bu === 'string') {
        items = row.campaign_bu ? [row.campaign_bu] : [];
      }
      
      setSelectedItems(items);
    } else {
      setSelectedItems([]);
    }
  }, [row.campaign_bu]);

  const handleSelectionChange = async (newSelection: string[]) => {
    // Immediately update local state to reflect the new selection (overwrite)
    setSelectedItems(newSelection);
    
    // Update the campaign_bu field with the new array (complete replacement)
    await updateRow(row.id, 'campaign_bu', newSelection);
  };

  // Return empty options during restructuring
  const formattedOptions: Option[] = [];

  return (
    <div className="w-full max-w-full overflow-hidden px-1 py-1">
      <MultiSelect
        options={formattedOptions}
        selected={selectedItems}
        onChange={handleSelectionChange}
        placeholder="Content ID (Restructuring...)"
        maxDisplay={3}
        className="w-full"
        disabled={true}
      />
    </div>
  );
};
